import request from '@/utilities/request'

// Audit Trail
export function getAuditTrails () {
  return request({
    url: '/auditTrails',
    method: 'get'
  })
}

export function getAuditTrail (id) {
  return request({
    url: '/auditTrails/' + id,
    method: 'get'
  })
}

export function searchAuditTrails (obj) {
  return request({
    url: '/auditTrails/search',
    method: 'post',
    data: obj
  })
}
